module.exports = __webpack_public_path__ + "img/IMG_1899_L_WoodMatted_MockedUp.1735ac14.jpg";